import gql from 'graphql-tag'

export const QUERY_EXTERNAL_BI_MENUS = gql`
  query {
    externalBIMenus(scope: ACCOUNT) {
      id
      name
      icon
      reports {
        id
        name
        route
        icon
        type
        config {
          ... on PowerBIConfig {
            datasetId
            workspaceId
            reportId
          }
          ... on LookerConfig {
            embedUrl
          }
        }
      }
    }
  }
`

export const MUTATION_GET_OR_CREATE_EXTERNAL_BI_EMBED_TOKEN = gql`
  mutation GetOrCreateExternalBIEmbedToken {
    getOrCreateExternalBIEmbedToken(scope: ACCOUNT) {
      token
      expiresAt
    }
  }
`
